module.exports = __webpack_public_path__ + "static/media/close.e95ef0fe.svg";